//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useGetSamplingCatalogProductsQuery } from '@campaigns/components/campaign-requests/sampling-campaigns/SamplingCampaignsQueries';
import { DEFAULT_LOCALE } from '@campaigns/constants/CampaignRequestsLocaleConstants';
import { useSamplingCampaign } from '@campaigns/hooks/useSamplingCampaign';

interface UseProductSearchProps {
  brandIds?: string[];
  categoryIds?: string[];
  enabled?: boolean;
  limit?: number;
  offset?: number;
  productIds?: string[];
  searchText?: string;
}

export const useProductSearch = ({
  brandIds,
  categoryIds,
  enabled = true,
  limit,
  offset,
  productIds,
  searchText,
}: UseProductSearchProps) => {
  const { samplingCampaignRequest, selectedRetailer } = useSamplingCampaign();

  return useGetSamplingCatalogProductsQuery(
    {
      brandIds,
      categoryIds,
      limit,
      locale: samplingCampaignRequest?.locale ?? DEFAULT_LOCALE,
      offset,
      productIds,
      retailerId: selectedRetailer?.clientId,
      searchText,
    },
    enabled,
  );
};
